// colorbox triggering for the rendered product link is in:
// ~//sites/maccosmetics/modules/custom/mac_product/libraries/mac_product_client_framework_v1/product_modules.js

(function ($) {
  'use strict';

  /**
   * estimated delivery
   */
  Drupal.behaviors.sppEstimatedDeliveryV1 = {
    attach: function (context, settings) {
      /* jshint -W069 */
      var dd = {};
      var $ddsubmit = $('.js-dd-submit', context),
        $ddresult = $('.js-dd-result', context),
        $ddinput = $('.js-dd-input', context),
        $ddterms = $('.delivery-date__terms', context),
        $ddtermsLink = $('.delivery-date__terms--link', context),
        $ddtermsCopy = $('.delivery-date__terms--copy', context),
        $ddResultError = $('.js-dd-result .error', context),
        $ddResultTable = $('.delivery-date__table', context);

      // @todo this needs some help
      // loading terms and conditions - need to know how to do this for mobile
      $ddtermsLink.on('click', function (el) {
        el.preventDefault();
        $ddtermsCopy.toggleClass('hidden');
        $.colorbox.resize();
      });

      $ddsubmit.on('click', function () {
        var ddPostalCode = $ddinput.val();

        $ddresult.removeClass('hidden');
        /* global generic */
        generic.jsonrpc.fetch({
          method: 'address.estimateDeliveryDateSPP',
          params: [
            {
              'POSTAL_CODE': ddPostalCode
            }
          ],
          onSuccess: function (jsonRpcResponse) {
            var logicData = jsonRpcResponse.getValue();

            dd.displayResult(logicData);
            $.colorbox.resize();
          },
          onError: function (jsonRpcResponse) {
            var errorObjectsArray = jsonRpcResponse.getMessages();

            // console.log(errorObjectsArray);
            generic.showErrors(errorObjectsArray, null, null);
          }
        });
      });

      dd.displayResult = function (data) {
        var display_order = ['us_nextday', 'us_2day', 'us_std', 'us_std_exact', 'us_territory', 'us_mil_pobox'],
          tableData = [];

        if (data[1]['is_valid_zipcode']) {
          $.each(data, function () {
            var orderIndex;

            if (this.type) {
              orderIndex = $.inArray(this.type, display_order);
              if (orderIndex !== -1) {
                tableData[orderIndex] = this;
              }
            }
          });
          dd.displayResultTable(tableData);
          $ddinput.removeClass('error');
          $ddResultError.hide();
        } else {
          $ddResultTable.addClass('hidden');
          $ddResultError.show();
          $ddResultError.html(site.translations.product.error_message_enter_valid_zip_code || 'Please enter a valid zip code.');
          $ddinput.addClass('error');
        }
      };

      dd.displayResultTable = function (data) {
        $ddResultTable.removeClass('hidden').find('tbody').empty();
        $.each(data, function () {
          if (this['type'] && this['type'] !== 'us_std' && this['type'] !== 'us_territory' && this['type'] !== 'us_mil_pobox' && this['type'] !== 'mx_std_exact' && this['type'] !== 'mx_territory' && this['type'] !== 'mx_mil_pobox') {
            var deliveryDate = this['min_day_name'] + ' ' + this['min_mon'] + '.' + this['min_day_num'];
            var shipment_option_text = this['shipment_option_text'];
            // we need to parse 'Standard (3-9 Bus days)' down to 'Standard' for output
            var match = shipment_option_text.match(/Standard/);

            if (match) {
              shipment_option_text = match[0];
            }

            if (this['max_day_num']) {
              deliveryDate = deliveryDate + ' - ' + this['max_day_name'] + ' ' + this['max_mon'] + '.' + this['max_day_num'];
            }
            var html = '<tr><td class="delivery-date__table--date">' + deliveryDate + '</td><td class="delivery-date__table--method">' + shipment_option_text + '</td></tr>';

            $ddResultTable.find('tbody').append(html);
          }
        });
      };
    }
  };
})(jQuery);
